import React from 'react';
import classNames from 'classnames';
import BredcrumbsIcon from '@/components/SvgComponents/BredcrumbsIcon';
import ActiveLink from '../ActiveLink/ActiveLink';

import styles from './Breadcrumbs.module.scss';

export default function Breadcrumbs({
  data,
  itemFullDetails,
  dark = false,
  className,
}) {
  if (!data?.length) return null;
  const renderList = (item, key) => {
    if (item?.slug) {
      return (
        <ActiveLink
          href={`/${item?.slug}`}
          key={key}
          itemScope
          itemType='https://schema.org/Property'
        >
          <a title={item?.text} aria-label={item?.text} className={styles.item}>
            {item?.text}
          </a>
        </ActiveLink>
      );
    }
    return (
      <span
        className={styles.item}
        key={key}
        itemScope
        itemType='https://schema.org/Text'
      >
        {item?.text}
      </span>
    );
  };

  return (
    <div
      className={classNames([
        styles.breadcrumbs,
        className,
        { [styles.dark]: dark },
      ])}
      itemScope
      itemType='https://schema.org/Bredcrumb'
    >
      <div className={classNames(['wrapper', styles.wrapper])}>
        {data?.map((item, key) => (
          <React.Fragment key={key}>
            {renderList(item, key)}
            {key < data.length - 1 && (
              <div className={styles.icon}>
                <BredcrumbsIcon />
              </div>
            )}
          </React.Fragment>
        ))}
        {itemFullDetails && (
          <div className={styles.icon}>
            <BredcrumbsIcon />
          </div>
        )}
      </div>
    </div>
  );
}
